module.exports = __webpack_public_path__ + "static/mountains-21139173d0f2998e7f7d2bc5e428410e.png";